import React, { useState, FC, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { useInView } from 'react-hook-inview';
import { useTranslation } from 'react-i18next';
import Slider from 'react-slick';

import UseCaseCardIcon1 from '../../../images/solutions/usecase-card-1-icon.svg';
import UseCaseCardIcon2 from '../../../images/solutions/usecase-card-2-icon.svg';
import UseCaseCardIcon3 from '../../../images/solutions/usecase-card-3-icon.svg';
import UseCaseCardIcon4 from '../../../images/solutions/usecase-card-4-icon.svg';
import {
  OtherCasesStyled,
  UseCasesDiagonalGrayTop,
  Title,
  CardsContainer,
  SliderContainer,
  PaginationPill,
  Card,
  CardMobile,
  CardIconContainer,
  CardOutter,
  CardTitle,
  Btn,
} from './style';

interface Props {
  currentCase: string | undefined;
}

const Others: FC<Props> = (props) => {
  const [activeSlide, setActiveSlide] = useState(1);
  const { t } = useTranslation();
  const [targetRef, isInViewport] = useInView({
    unobserveOnEnter: true,
  });

  const settings = {
    dots: false,
    arrows: true,
    infinite: false,
    autoplay: false,
    speed: 500,
    slidesToShow: 1.2,
    slidesToScroll: 1,
    beforeChange: (current: number, next: number) => {
      if (next < 1.8) {
        setActiveSlide(next + 1);
      } else {
        setActiveSlide(next + 1.2);
      }
    },
  };

  const cardPath = [...Array(4)].map((_, index) => {
    return `/solutions/usecase/${index + 1}-${t(
      `SolutionUseCasesCard${index + 1}Title`
    )
      .toLowerCase()
      .replace(/ /g, '-')}`.toString();
  });

  const mobileSlideCards = (
    <>
      <CardMobile>
        <CardIconContainer>
          <img src={UseCaseCardIcon1} alt="icon" />
        </CardIconContainer>
        <CardTitle>{t('SolutionUseCasesCard1Title')}</CardTitle>
        <Link to={cardPath[0]}>
          <Btn>{t('SolutionUseCasesCardBtn')}</Btn>
        </Link>
      </CardMobile>
      <CardMobile>
        <CardIconContainer>
          <img src={UseCaseCardIcon2} alt="icon" />
        </CardIconContainer>
        <CardTitle>{t('SolutionUseCasesCard2Title')}</CardTitle>
        <Link to={cardPath[1]}>
          <Btn>{t('SolutionUseCasesCardBtn')}</Btn>
        </Link>
      </CardMobile>
      <CardMobile>
        <CardIconContainer>
          <img src={UseCaseCardIcon3} alt="icon" />
        </CardIconContainer>
        <CardTitle>{t('SolutionUseCasesCard3Title')}</CardTitle>
        <Link to={cardPath[2]}>
          <Btn>{t('SolutionUseCasesCardBtn')}</Btn>
        </Link>
      </CardMobile>
      <CardMobile>
        <CardIconContainer>
          <img src={UseCaseCardIcon4} alt="icon" />
        </CardIconContainer>
        <CardTitle>{t('SolutionUseCasesCard4Title')}</CardTitle>
        <Link to={cardPath[3]}>
          <Btn>{t('SolutionUseCasesCardBtn')}</Btn>
        </Link>
      </CardMobile>
    </>
  ).props.children.filter(
    (_: any, index: number) => index + 1 !== Number(props.currentCase)
  );

  const slider = useRef<any>();
  useEffect(() => {
    slider.current.slickGoTo(0);
  }, [props.currentCase]);

  return (
    <OtherCasesStyled ref={targetRef}>
      <UseCasesDiagonalGrayTop />
      <div className="container">
        <div className="desktop">
          <Title>{t('UseCaseOtherCasesTitle')}</Title>
          <CardsContainer>
            <CardOutter
              className={
                isInViewport && props.currentCase === '1'
                  ? 'animate__animated animate__fadeInUp animate__faster'
                  : 'animate__animated animate__fadeInUp animate__faster showing'
              }
            >
              <Card>
                <CardIconContainer>
                  <img src={UseCaseCardIcon1} alt="icon" />
                </CardIconContainer>
                <CardTitle>{t('SolutionUseCasesCard1Title')}</CardTitle>
                <Link to={cardPath[0]}>
                  <Btn>{t('SolutionUseCasesCardBtn')}</Btn>
                </Link>
              </Card>
            </CardOutter>
            <CardOutter
              className={
                isInViewport && props.currentCase === '2'
                  ? 'animate__animated animate__fadeInUp animate__faster'
                  : 'animate__animated animate__fadeInUp animate__faster showing'
              }
            >
              <Card>
                <CardIconContainer>
                  <img src={UseCaseCardIcon2} alt="icon" />
                </CardIconContainer>
                <CardTitle>{t('SolutionUseCasesCard2Title')}</CardTitle>
                <Link to={cardPath[1]}>
                  <Btn>{t('SolutionUseCasesCardBtn')}</Btn>
                </Link>
              </Card>
            </CardOutter>
            <CardOutter
              className={
                isInViewport && props.currentCase === '3'
                  ? 'animate__animated animate__fadeInUp animate__faster'
                  : 'animate__animated animate__fadeInUp animate__faster showing'
              }
            >
              <Card>
                <CardIconContainer>
                  <img src={UseCaseCardIcon3} alt="icon" />
                </CardIconContainer>
                <CardTitle>{t('SolutionUseCasesCard3Title')}</CardTitle>
                <Link to={cardPath[2]}>
                  <Btn>{t('SolutionUseCasesCardBtn')}</Btn>
                </Link>
              </Card>
            </CardOutter>
            <CardOutter
              className={
                isInViewport && props.currentCase === '4'
                  ? 'animate__animated animate__fadeInUp animate__faster'
                  : 'animate__animated animate__fadeInUp animate__faster showing'
              }
            >
              <Card>
                <CardIconContainer>
                  <img src={UseCaseCardIcon4} alt="icon" />
                </CardIconContainer>
                <CardTitle>{t('SolutionUseCasesCard4Title')}</CardTitle>
                <Link to={cardPath[3]}>
                  <Btn>{t('SolutionUseCasesCardBtn')}</Btn>
                </Link>
              </Card>
            </CardOutter>
          </CardsContainer>
        </div>
      </div>

      <SliderContainer>
        <Title>{t('UseCaseOtherCasesTitle')}</Title>
        <Slider {...settings} ref={slider}>
          {mobileSlideCards}
        </Slider>
        <PaginationPill>{activeSlide}/3</PaginationPill>
      </SliderContainer>
    </OtherCasesStyled>
  );
};

export default Others;
